import {
  defaultTransitionClass,
  themeVars,
  toBorder,
  nToPx,
} from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';
import { SelectableCardVariant } from './SelectableCard.types';

export const cardReadonlyClass = style({});

export const cardDisabledClass = style({
  opacity: 0.5,
  cursor: 'not-allowed',
});

export const cardSelectedClass = styleVariants({
  [SelectableCardVariant.DEFAULT]: {},
  [SelectableCardVariant.OPTION]: {
    border: toBorder({
      width: 2,
      color: themeVars.colors.brand.primary.x50,
    }),
    borderRadius: themeVars.radius.md,
  },
});

export const cardSingleCardClass = style({
  borderRadius: themeVars.radius.md,
});

const cardContainerBaseClass = style([
  defaultTransitionClass,
  {
    display: 'flex',
    gap: themeVars.space.x4,
    padding: nToPx(themeVars.space.x3, themeVars.space.x4),
    backgroundColor: themeVars.colors.neutrals.grey10,
    textAlign: 'left',

    selectors: {
      [`&:hover:not(${cardReadonlyClass}):not(${cardDisabledClass})`]: {
        backgroundColor: themeVars.colors.brand.primary.x2,
      },
    },
  },
]);

export const cardContainerClass = styleVariants({
  [SelectableCardVariant.DEFAULT]: [
    cardContainerBaseClass,
    {
      maxWidth: 380,
      border: toBorder('transparent'),
      alignItems: 'center',

      selectors: {
        [`&:first-child:not(${cardSingleCardClass})`]: {
          borderRadius: `${themeVars.radius.md} ${themeVars.radius.md} 0 0`,
        },
        [`&:last-child:not(${cardSingleCardClass})`]: {
          borderRadius: `0 0 ${themeVars.radius.md} ${themeVars.radius.md}`,
        },
      },
    },
  ],
  [SelectableCardVariant.OPTION]: [
    cardContainerBaseClass,
    {
      position: 'relative',
      alignItems: 'flex-start',
      borderRadius: themeVars.radius.md,

      selectors: {
        [`&:active:not(${cardReadonlyClass})`]: {
          border: toBorder(themeVars.colors.neutrals.grey50),
        },
      },
    },
  ],
});

export const textClass = style({
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.bold,
});

const cardIconContainerBaseClass = style({
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center',
  width: 40,
  height: 40,
  borderRadius: themeVars.radius.md,
  color: themeVars.colors.neutrals.black100,
});

export const cardIconContainerClass = styleVariants({
  [SelectableCardVariant.DEFAULT]: [cardIconContainerBaseClass],
  [SelectableCardVariant.OPTION]: [
    cardIconContainerBaseClass,
    { backgroundColor: themeVars.colors.brand.primary.x5 },
  ],
});

export const cardIconSelectedClass = style({
  backgroundColor: themeVars.colors.brand.primary.x100,
  color: themeVars.colors.neutrals.white,
});

export const cardIconClass = style({
  fontSize: themeVars.font.size.iconMd,
});

export const cardContentClass = style({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const cardTitleClass = style({
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.bold,
});

export const cardDescriptionClass = style({
  fontSize: themeVars.font.size.textMd,
  wordWrap: 'normal',
  lineHeight: 1.5,
  whiteSpace: 'pre-line',
});

export const cardSmallGapClass = style({
  gap: 0,
});

export const cardSelectionContainerIconClass = style({
  color: themeVars.colors.brand.primary.x100,
  width: 30,
  minWidth: 30,
});

export const cardSelectionIconClass = style({
  fontSize: `${themeVars.font.size.iconXl}!important`,
});
